<template>
  <div>
    <div>
      <div class="d-flex flex-wrap">
        <div v-for="(image,index) in formatedImages" :key="index" class="mb-2 mr-2" style="cursor:pointer;">
          <img style="height: 80px;width: 80px;border: 1px solid #c8c8c8;" v-lazy="image.src || image.thumb" @click="openGallery(index)"/>
        </div>  
      </div>
      

      <LightBox
        ref="lightbox"
        :media="formatedImages"
        :show-caption="true"
        :show-light-box="false"
      />
    </div>
  </div>
</template>
<script>
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

export default {
  beforeMount() {
    for (let index = 0; index < this.images.length; index++) {
      this.formatedImages.push({
        thumb: this.images[index].base64,
        src: this.images[index].base64,
        caption:'<a class="text-white" href="' +this.images[index].base64 +'" target="_blank">' +this.images[index].fileName +"</a>", // Optional
      });
    }
  },
  props: {
    images: {
      required: true,
    },
  },
  data() {
    return {
      formatedImages: [],
    };
  },
  components: {
    LightBox,
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    }
  }
  
};
</script>
<style lang="scss">
  .vue-lb-info{
    word-break: break-all;
  }
  .vue-lb-container{
    z-index: 9999 !important;
  }
  .vue-lb-button-close{
    position: fixed;
    top: 40px;
    right: 40px;
    margin-right: 0 !important;
    padding: 0 !important;
  }
</style>